function getRouteForError(error) {
  if (error && error.route) {
    return `/error/${error.route}`;
  }
  if (error && error.response) {
    switch (error.response.status) {
      case 401:
      case 403:
        return '/error';
      case 500:
        return '/error';
      default:
        break;
    }
  }

  return '/error';
}

export default history => err => {
  const route = getRouteForError(err);
  history.push(route);
};
